var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 2.16663C5.40866 2.16663 1.66699 5.90829 1.66699 10.5C1.66699 15.0916 5.40866 18.8333 10.0003 18.8333C14.592 18.8333 18.3337 15.0916 18.3337 10.5C18.3337 5.90829 14.592 2.16663 10.0003 2.16663ZM9.37533 7.16663C9.37533 6.82496 9.65866 6.54163 10.0003 6.54163C10.342 6.54163 10.6253 6.82496 10.6253 7.16663V11.3333C10.6253 11.675 10.342 11.9583 10.0003 11.9583C9.65866 11.9583 9.37533 11.675 9.37533 11.3333V7.16663ZM10.767 14.15C10.7253 14.2583 10.667 14.3416 10.592 14.425C10.5087 14.5 10.417 14.5583 10.317 14.6C10.217 14.6416 10.1087 14.6666 10.0003 14.6666C9.89199 14.6666 9.78366 14.6416 9.68366 14.6C9.58366 14.5583 9.49199 14.5 9.40866 14.425C9.33366 14.3416 9.27533 14.2583 9.23366 14.15C9.19199 14.05 9.16699 13.9416 9.16699 13.8333C9.16699 13.725 9.19199 13.6166 9.23366 13.5166C9.27533 13.4166 9.33366 13.325 9.40866 13.2416C9.49199 13.1666 9.58366 13.1083 9.68366 13.0666C9.88366 12.9833 10.117 12.9833 10.317 13.0666C10.417 13.1083 10.5087 13.1666 10.592 13.2416C10.667 13.325 10.7253 13.4166 10.767 13.5166C10.8087 13.6166 10.8337 13.725 10.8337 13.8333C10.8337 13.9416 10.8087 14.05 10.767 14.15Z",
    fill: "#4A878D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.0192eafa91463eaf93a94c2f7bd4ba9c.svg";
export { ForwardRef as ReactComponent };